import styled from 'styled-components'

const ParagraphStyled = styled.p`
  font-weight: ${(props) => props.weight};
  font-size: ${(props) => props.size};
  font-family: ${(props) => props.font};
`

export default ParagraphStyled
